module.exports = __webpack_public_path__ + "img/logo.05375642.webp";